module.exports = __webpack_public_path__ + "img/highlights2-s.bfa12956.png";